import React from 'react';

import PropTypes from 'prop-types';

import PaylineLegacy from './PaylineLegacy/PaylineLegacy';
import PaylineWebPayment from './PaylineWebPayment/PaylineWebPayment';

/**
 * Single entrypoint for the Payline PSP.
 *
 * The backend decides which flow to use via `config.use_web_payment`:
 *   - true  -> Monext/Payline web widget (PaylineWebPayment)
 *   - false -> legacy tokenizer-based flow + Apple/Google Pay (PaylineLegacy)
 *
 * Keeping one wrapper means PspComposer does not need to know which
 * implementation is active and both flows can be rolled out/back purely
 * from backend configuration.
 */
const Payline = React.forwardRef((props, ref) => {
    if (props.config?.use_web_payment === true) {
        return <PaylineWebPayment ref={ref} {...props} />;
    }
    return <PaylineLegacy ref={ref} {...props} />;
});

Payline.propTypes = {
    config: PropTypes.object,
    paymentMethodId: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
};

Payline.displayName = 'Payline';

export default Payline;
